import client from '/src/services/client.js';

export default {
    getDatasetsIvy : (data) => client.get('datasets', {...data, ...{type : 1}}),
    getDatasetsWorksheet : (data) => client.get('datasets', {...data, ...{type : 3}}),
    getDatasets: (companies_ids,data) => client.get('datasets', {...data, ...{companies_ids : companies_ids}}),
    getDataset : (name, data)=> client.get(`dataset/${name}/statements`, data),
    addDataset : (data)=> client.post(`dataset`, data),
    deleteDataset : (name, data) => client.delete(`dataset/${name}`, data),
    updateDataset : (id, data)=> client.put(`dataset/${id}`, data),
    isDatasetNameAvailable : (name) => client.get(`datasets?name=${name}`),
}